import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PublicNav } from "@/components/PublicNav";
import { Footer } from "@/components/Footer";
import { PrototypeBanner } from "@/components/PrototypeBanner";
import { Button } from "@/components/ui/button";
import {
  Stethoscope, Activity, HeartPulse, Brain, MessageSquare, UserCheck, Plus,
  CheckCircle2, Clock, Loader2, ArrowRight,
} from "lucide-react";

const ICONS = { Activity, HeartPulse, MessageSquare, Brain, Stethoscope, UserCheck, Plus };

export default function Servizi() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["services-all"], queryFn: async () => (await api.get("/services?only_active=false")).data });
  const services = data?.services || [];

  return (
    <div className="min-h-screen bg-white">
      <PrototypeBanner />
      <PublicNav />
      <section className="bg-[#EAF3EF] py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#102A2A]">Servizi sanitari a domicilio</h1>
          <p className="mt-3 text-lg text-[#5C6B68] max-w-2xl">
            Prestazioni medico-sanitarie eseguite al tuo domicilio da personale abilitato ad Arezzo e provincia.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {isLoading ? (
          <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#087A73]" /></div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s) => {
              const Icon = ICONS[s.icon] || Stethoscope;
              const soon = !s.active;
              return (
                <div key={s.id} data-testid={`service-card-${s.slug}`}
                  className="relative bg-white rounded-2xl border border-[#D2E3DB] shadow-sm p-7 flex flex-col hover:shadow-md transition-all">
                  {soon && <span data-testid={`service-soon-${s.slug}`} className="absolute top-5 right-5 bg-[#FBF0D6] text-[#8a6400] text-xs font-bold px-3 py-1 rounded-full border border-[#D99A00]/40">Prossimamente</span>}
                  <span className={`h-14 w-14 rounded-2xl flex items-center justify-center mb-5 ${soon ? "bg-[#EAF3EF] text-[#087A73]" : "bg-[#087A73] text-white"}`}><Icon className="h-7 w-7" /></span>
                  <h3 className="text-xl font-bold text-[#102A2A] mb-2">{s.name}</h3>
                  <p className="text-sm text-[#5C6B68] leading-relaxed flex-1">{s.description}</p>
                  <div className="mt-5 pt-5 border-t border-[#EAF3EF] flex items-center justify-between">
                    {soon ? (
                      <span className="text-sm font-semibold text-[#8a6400]">Disponibile prossimamente</span>
                    ) : (
                      <>
                        <span className="text-lg font-bold text-[#087A73]">Tariffa su richiesta</span>
                        <span className="text-xs text-[#5C6B68] flex items-center gap-1"><CheckCircle2 className="h-4 w-4 text-[#087A73]" /> A domicilio</span>
                      </>
                    )}
                  </div>
                  {soon ? (
                    <Button data-testid={`service-request-${s.slug}`} disabled
                      className="mt-4 w-full bg-[#EAF3EF] text-[#5C6B68] rounded-xl h-12 font-semibold cursor-not-allowed hover:bg-[#EAF3EF]">
                      Prossimamente
                    </Button>
                  ) : (
                    <Button data-testid={`service-request-${s.slug}`} onClick={() => navigate("/login?role=patient")}
                      className="mt-4 w-full bg-[#087A73] hover:bg-[#06615B] text-white rounded-xl h-12 font-semibold">
                      Richiedi <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  )}
                </div>
              );
            })}
          </div>
        )}
        <p className="mt-10 text-center text-sm text-[#5C6B68]">
          La tariffa viene concordata direttamente con il professionista in base alla prestazione richiesta.
        </p>
      </section>
      <Footer />
    </div>
  );
}
